/**
 * @generated SignedSource<<65ba02d3ee99e5356bab0224db939285>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "VersionType",
    "kind": "LinkedField",
    "name": "getVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetVersionQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GetVersionQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ab6a81f74d220de7354297640c15b80b",
    "id": null,
    "metadata": {},
    "name": "GetVersionQuery",
    "operationKind": "query",
    "text": "query GetVersionQuery {\n  getVersion {\n    version\n  }\n}\n"
  }
};
})();

node.hash = "dc92cda9b60ec924572f8071c880d021";

module.exports = node;
